import React from "react";
import dayjs from "dayjs";
import { CheckCircle, XCircle, Clock } from "react-feather";

const AttemptTimeline = ({ attempts, selectedAttemptNumber, onSelect }) => {
  return (
    <div className="d-flex flex-column gap-2">
      {attempts.map((attempt) => {
        const isSelected = attempt.attemptNumber === selectedAttemptNumber;
        const isKnownOutcome = attempt.passed !== null;

        return (
          <button
            key={attempt.attemptNumber}
            type="button"
            onClick={() => onSelect(attempt.attemptNumber)}
            className="text-start border rounded-3 p-2 bg-white"
            style={{
              cursor: "pointer",
              borderColor: isSelected ? "#224B99" : "#dee2e6",
              borderWidth: isSelected ? "2px" : "1px",
              boxShadow: isSelected ? "0 2px 6px rgba(34,75,153,0.15)" : "none",
            }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <span className="fw-bold small" style={{ color: "#224B99" }}>
                Attempt {attempt.attemptNumber}
              </span>
              {isKnownOutcome ? (
                attempt.passed ? (
                  <span className="d-flex align-items-center gap-1 text-success small fw-bold">
                    <CheckCircle size={14} /> Passed
                  </span>
                ) : (
                  <span className="d-flex align-items-center gap-1 text-danger small fw-bold">
                    <XCircle size={14} /> Failed
                  </span>
                )
              ) : (
                <span className="badge bg-secondary">Legacy</span>
              )}
            </div>
            <div className="d-flex align-items-center gap-1 text-muted mt-1" style={{ fontSize: "0.75rem" }}>
              <Clock size={12} />
              {attempt.submittedAt ? dayjs(attempt.submittedAt).format("MMM D, YYYY h:mm A") : "Date unavailable"}
            </div>
            <div className="mt-1 small">
              {attempt.totalQuestions ? (
                <>
                  <span className="fw-bold">{attempt.correctQuestions}</span>/{attempt.totalQuestions} correct
                  <span className="text-muted"> · {attempt.percentage.toFixed(0)}%</span>
                </>
              ) : (
                <span className="text-muted">Score: {attempt.percentage.toFixed(0)}%</span>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default AttemptTimeline;
